import React from 'react';
import { AlertTriangle, Info, XCircle } from 'lucide-react';

const ICONS = {
  ERROR: { Icon: XCircle, className: 'mse-sev-error', label: 'Error' },
  WARN: { Icon: AlertTriangle, className: 'mse-sev-warn', label: 'Warning' },
  INFO: { Icon: Info, className: 'mse-sev-info', label: 'Note' },
};

export const SeverityIcon = ({ severity, size = 14 }) => {
  const { Icon, className, label } = ICONS[severity] || ICONS.INFO;
  return <Icon size={size} className={className} aria-label={label} />;
};

/** A list of SEO findings; rows with a unit are buttons that focus it. */
const SeoFindings = ({ findings, onFocusUnit }) => (
  <ul className="mse-findings">
    {findings.map((f, i) => {
      const clickable = f.unitId && onFocusUnit;
      const body = (
        <>
          <SeverityIcon severity={f.severity} />
          <span className="mse-finding-text">
            <span className="mse-finding-title">{f.title}</span>
            <span className="mse-finding-message">{f.message}</span>
          </span>
        </>
      );
      return (
        <li key={`${f.rule}-${f.unitId || ''}-${i}`} className={`mse-finding sev-${f.severity.toLowerCase()}`}>
          {clickable ? (
            <button type="button" className="mse-finding-button" onClick={() => onFocusUnit(f.unitId)}>
              {body}
            </button>
          ) : (
            <div className="mse-finding-button">{body}</div>
          )}
        </li>
      );
    })}
  </ul>
);

export default SeoFindings;
